import type { VerificationType } from '../types';
import { useSiteCopy } from '../content/SiteCopyContext';

export function VerificationBadge({ type, showLabel = false }: { type?: VerificationType; showLabel?: boolean }) {
  const copy = useSiteCopy();
  if (!type || type === 'none') return null;
  const label = type === 'blue' ? copy('verification.blue') : copy('verification.yellow');
  return <span className={`verification-badge ${type}${showLabel ? ' labeled' : ''}`} title={label} aria-label={label}>
    <svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="9" /><path d="m5.8 6.6 3.6 7 4.8-8" /></svg>
    {showLabel && <span>{label}</span>}
  </span>;
}
